import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { RapportDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/rapport-dto';
import { ServiceRapportService } from 'src/app/api/services';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';

@Component({
    selector: 'app-rapporter',
    templateUrl: './rapporter.component.html',
    styleUrls: ['./rapporter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RapporterComponent implements OnInit {
  @Input() rapporter: RapportDto[];
  @Input() serviceOrdreNo: number;
  constructor(private reportService: ServiceRapportService, private errorHandler: ErrorHandlerService) {}

  unsubscribe$ = new Subject<void>();

  ngOnInit(): void {}

  getDownloadLink(id: number) {
    this.reportService
      .getServiceRapportUrl({ caller: EGIS_SERVICE_CALLER, rapportId: id, serviceordreNo: this.serviceOrdreNo })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (response: string) => {
          window.open(response, '_blank');
        },
        (error) => {
          this.errorHandler.HandleError(error);
        }
      );
  }
}
